import { baseRoute } from "../routes";

// Built from the site root, never the current page: a QR code is printed once and must open the form from wherever it was made.
const publicFormLink = (form: string, externalId: string, origin = window.location.origin) =>
    `${origin}${baseRoute}/${form}?externalId=${encodeURIComponent(externalId)}`;

export const reportIssueLink = (externalId: string, origin?: string) => publicFormLink("report-issue", externalId, origin);

export const reportIncidentLink = (externalId: string, origin?: string) => publicFormLink("report-incident", externalId, origin);
